export default {
    name: 'Home',
    path: '/',
    meta: {
      title: 'momo the cat'
    }
  };
  